import type { ApiProdutor } from "pages/produtores/types/ApiProdutor";
import { type ApiResponse, newRequest } from "std/api/newRequest";
import type { ApiRelatorioGetParams } from "../types/ApiRelatorioParams";

export function apiRelProdutores({ params }: { params: ApiRelatorioGetParams }): Promise<ApiResponse<ApiProdutor>> {
	return newRequest({
		url: "Relatorio/Produtores",
		type: "get",
		idpk: undefined,
		params,
	});
}
